import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    marginTop: 30,
  },
  tableTitle: {
    fontSize: "15px",
    color: "#ffffff",
    backgroundColor: "#01539a",
    lineHeight: "1",
    padding: "8px",
  },
  tableRow: {
    height: 30, // Adjust row height here
  },
  tableCell: {
    padding: "4px 8px", // Reduce padding
    lineHeight: "1.2", // Adjust line height to control text positioning
    verticalAlign: "bottom", // Position text at the bottom
  },
});

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData("Frozen yoghurt", 159, 6.0, 24, 4.0),
  createData("Ice cream sandwich", 237, 9.0, 37, 4.3),
  createData("Eclair", 262, 16.0, 24, 6.0),
  createData("Cupcake", 305, 3.7, 67, 4.3),
  createData("Gingerbread", 356, 16.0, 49, 3.9),
];

export default function FixedFeeSchedule() {
  const classes = useStyles();

  return (
    <TableContainer>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow className={classes.tableTitle}>
            <TableCell className={classes.tableTitle} style={{ width: 300 }}>
              Fixed Fee Schedule Forecast
            </TableCell>
            <TableCell className={classes.tableTitle} align="right">
              Jun 24
            </TableCell>
            <TableCell className={classes.tableTitle} align="right">
              Jul 24
            </TableCell>
            <TableCell className={classes.tableTitle} align="right">
              Aug 24
            </TableCell>
            <TableCell className={classes.tableTitle} align="right">
              Sep 24
            </TableCell>
            <TableCell className={classes.tableTitle} align="right">
              Oct 24
            </TableCell>
            <TableCell className={classes.tableTitle} align="right">
              Nov 24
            </TableCell>
            <TableCell className={classes.tableTitle} align="right">
              Dec 24
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={classes.tableRow}>
            <TableCell component="th" scope="row" className={classes.tableCell}>
              Revenue Projections
            </TableCell>
            <TableCell align="right" className={classes.tableCell}></TableCell>
            <TableCell align="right" className={classes.tableCell}></TableCell>
            <TableCell align="right" className={classes.tableCell}></TableCell>
            <TableCell align="right" className={classes.tableCell}></TableCell>
            <TableCell align="right" className={classes.tableCell}></TableCell>
            <TableCell align="right" className={classes.tableCell}></TableCell>
            <TableCell align="right" className={classes.tableCell}></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
